<template>
    <a
        class="lds-widget-card"
        target="_blank"
        :href="offer.url"
        :class="offerClasses(offer.params.advantage)"
    >
        <ShowcaseOffersAdvantage
            v-if="uspPlacement === advantagesPlacement.OUTSIDE && offer.params.advantage"
            :advantage="offer.params.advantage.string"
        />
        <div class="lds-widget-card__wrapper">
            <ShowcaseOffersAdvantage
                v-if="uspPlacement === advantagesPlacement.INSIDE && offer.params.advantage"
                :advantage="offer.params.advantage.string"
            />
            <div class="lds-widget-card__row">
                <div class="lds-widget-card__container">
                    <div class="lds-widget-card__img">
                        <img
                            :src="offer.logoUrl"
                            :alt="offer.siteName"
                        >
                    </div>
                    <ShowcaseOffersApproval
                        v-if="offer.siteName"
                        :offer-name="offer.siteName"
                        :param-name="offer.params.approval?.name"
                        :param-value="offer.params.approval?.string"
                    />
                    <div class="lds-widget-card__params">
                        <div class="lds-widget-card__block">
                            <ShowcaseOfferParams
                                v-if="offer.params.rkoTariffCost"
                                :name="offer.params.rkoTariffCost.name"
                                :value="'от ' + offer.params.rkoTariffCost.string + ' ' + tariffSymbol"
                                class="lds-widget-card__item_big"
                            />
                        </div>
                        <div class="lds-widget-card__block">
                            <ShowcaseOfferParams
                                v-if="offer.params.rkoCash"
                                :name="offer.params.rkoCash.name"
                                :value="'от ' + offer.params.rkoCash.string + '%'"
                            />
                            <ShowcaseOfferParams
                                v-if="offer.params.rkoTransfers"
                                :name="offer.params.rkoTransfers.name"
                                :value="offer.params.rkoTransfers.string"
                            />
                        </div>
                    </div>
                </div>
                <span class="se-btn lds-widget-card__btn">{{ textBtn }}</span>
            </div>
        </div>
    </a>
</template>

<script setup>
import { inject } from 'vue';
import ShowcaseOffersAdvantage from '../ShowcaseOfferParams/ShowcaseOffersAdvantage.vue';
import ShowcaseOfferParams from '../ShowcaseOfferParams/ShowcaseOfferParams.vue';
import commonProps from '../../common/сommonProps.js';
import advantagesPlacement from '../../common/advantagesPlacement.js';
import showcaseOfferClasses from '../../common/showcaseOfferClasses.js';
import ShowcaseOffersApproval from '../ShowcaseOfferParams/ShowcaseOffersApproval.vue';

const props = defineProps({
    offer: {
        type: Object,
        required: true,
    },
    ...commonProps(),
});

const currencySymbol = inject('currencySymbol');
const tariffSymbol = ` ${currencySymbol.value}/мес.`;
const { offerClasses } = showcaseOfferClasses(props);

</script>
<style lang="scss" scoped>
@import '../../assets/styles/design1/offer';
</style>